function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Create a proxy for our logger package.
 *
 * This saves adding the logger package as a dependency and drastically
 * increasing the bundle size, but means we can continue getting the benefits
 * of structured logging.
 */
var createHandler = function createHandler(loggerName) {
  return {
    get: function get(target, property) {
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        window.IM = window.IM || {};
        window.IM.logger = window.IM.logger || {
          queue: []
        }; // If a logger has already been assigned to `target` (see below) and it
        // contains the given function (e.g. `log()`) then call it

        if (target[property]) {
          target[property].apply(target, args);
          return;
        } // Otherwise queue up the logging function


        window.IM.logger.queue.push(function () {
          var logger = window.IM.logger.withName(loggerName); // Assign the new logger to `target` to save creating it next time

          Object.assign(target, logger); // Call the logger function

          logger[property].apply(logger, args);
        });
      };
    }
  };
}; // IE/testing fallback.


var fallback = _objectSpread(_objectSpread({}, console), {}, {
  withName: function withName() {
    return console;
  },
  withMeta: function withMeta() {
    return console;
  }
});
/**
 * Create a logger with a custom name.
 */


export var createLogger = function createLogger(loggerName) {
  return typeof Proxy === 'undefined' || process.env.NODE_ENV === 'test' ? fallback : new Proxy({}, createHandler(loggerName));
};